module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// ./node_modules/.2.5.7@core-js/library/modules/_add-to-unscopables.js
// module id = 455
// module chunks = 1